export const routes = [
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/opt/buildhome/repo/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/avatar-model-profiles',
    /* internal name: '/avatar-model-profiles' */
    /* no component */
    children: [
      {
        path: '',
        name: '/avatar-model-profiles/',
        component: () => import('/opt/buildhome/repo/src/pages/avatar-model-profiles/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/avatars',
    /* internal name: '/avatars' */
    /* no component */
    children: [
      {
        path: '',
        name: '/avatars/',
        component: () => import('/opt/buildhome/repo/src/pages/avatars/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/avatars/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/avatars/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/collection-tasks',
    /* internal name: '/collection-tasks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/collection-tasks/',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/collection-tasks/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/collection-tasks/new',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/config',
    /* internal name: '/config' */
    /* no component */
    children: [
      {
        path: '',
        name: '/config/',
        component: () => import('/opt/buildhome/repo/src/pages/config/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/config/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/config/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/developer-keys',
    /* internal name: '/developer-keys' */
    /* no component */
    children: [
      {
        path: '',
        name: '/developer-keys/',
        component: () => import('/opt/buildhome/repo/src/pages/developer-keys/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/developer-keys/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/developer-keys/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/driving-models',
    /* internal name: '/driving-models' */
    /* no component */
    children: [
      {
        path: '',
        name: '/driving-models/',
        component: () => import('/opt/buildhome/repo/src/pages/driving-models/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    },
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/opt/buildhome/repo/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/prompts',
    /* internal name: '/prompts' */
    /* no component */
    children: [
      {
        path: '',
        name: '/prompts/',
        component: () => import('/opt/buildhome/repo/src/pages/prompts/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reconmodel-v2',
    /* internal name: '/reconmodel-v2' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reconmodel-v2/',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/index.vue'),
        /* no children */
      },
      {
        path: ':version',
        name: '/reconmodel-v2/[version]',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/[version].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/reconmodel-v2/new',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reconstruction-v2',
    /* internal name: '/reconstruction-v2' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reconstruction-v2/',
        component: () => import('/opt/buildhome/repo/src/pages/reconstruction-v2/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/reconstruction-v2/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/reconstruction-v2/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/opt/buildhome/repo/src/pages/register.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    },
  },
  {
    path: '/services',
    /* internal name: '/services' */
    /* no component */
    children: [
      {
        path: '',
        name: '/services/',
        component: () => import('/opt/buildhome/repo/src/pages/services/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/opt/buildhome/repo/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/sms-send-logs',
    /* internal name: '/sms-send-logs' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sms-send-logs/',
        component: () => import('/opt/buildhome/repo/src/pages/sms-send-logs/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/video-generation',
    /* internal name: '/video-generation' */
    /* no component */
    children: [
      {
        path: '',
        name: '/video-generation/',
        component: () => import('/opt/buildhome/repo/src/pages/video-generation/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/video-generation/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/video-generation/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/video-generation/new',
        component: () => import('/opt/buildhome/repo/src/pages/video-generation/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/video-materials',
    /* internal name: '/video-materials' */
    /* no component */
    children: [
      {
        path: '',
        name: '/video-materials/',
        component: () => import('/opt/buildhome/repo/src/pages/video-materials/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/video-materials/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/video-materials/[id].vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

